/***************************************************************************************************
** evaluateConditional
***************************************************************************************************/

import typeOf from "@utils/helpers/object/typeOf";

export default function evaluateConditional(conditional, data = {}) {
  switch (typeOf(conditional)) {
  case "array": {
    const [key, value] = conditional;

    return (data[key] === value);
  }

  case "object": {
    const [key, value] = Object.entries(conditional)[0];

    if (typeOf(value) === "array") {
      return value.includes(data[key]);
    } else {
      return (data[key] === value);
    }
  }

  case "string": {
    return conditional === "false" ? false : true;
  }

  case "boolean": {
    return conditional;
  }

  default:
    return Boolean(conditional);
  }
}
